import React from "react";

function NFTMarketDevSer() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                NFT Marketplace Development Service By Xeer Technology
              </h2>
              <p>
                At Xeer Technology, we specialize in crafting cutting-edge NFT
                marketplace solutions that cater to diverse industries and
                audiences. Our NFT Marketplace Development Service encompasses
                every aspect of creating a thriving platform where users can
                mint, buy, sell, and trade non-fungible tokens with ease and
                security.
              </p>

              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NFTMarketDevSer;
